import React, { useMemo } from "react";
import { useParams, useHistory } from "react-router";
import { Row, Col } from "antd";
import styles from "./ModeSelection.module.scss";
import { useTripsCtx } from "../../../context/TripDetailsContext";
import VehicleCard from "../../Shared/VehicleCard/VehicleCard";
import CustomButton from "../../../common/Buttons/CustomButton";
import { backArrowIcon } from "../../../assets/images";
interface IParams {
  serviceUserId: string;
}

const ModeSelection = () => {
  const params = useParams<IParams>();
  const history = useHistory();

  const {
    modeSelectionBackBtnCtx,
    serviceDataCtx,
    wandaTripInfoCtx,
  } = useTripsCtx();
  const [, setIsModeSelectionBackBtnClicked] = modeSelectionBackBtnCtx;
  const [serviceData] = serviceDataCtx;
  const [wandaTripInfo] = wandaTripInfoCtx;

  const memoizedDisplayOptions = useMemo(() => {
    const serviceUser = serviceData?.find(
      (data: { personId: number }) =>
        data.personId === Number(params.serviceUserId)
    );
    const wheelchair = serviceUser?.wandaAccommodations?.wheelChairTravel;
    const standardFoldable =
      serviceUser?.wandaAccommodations?.wheelChairPresent;
    const transfer = serviceUser?.wandaAccommodations?.wcToVehicleTransfer;

    const displayStandard = !wheelchair;
    const displayWAV = wheelchair && !(standardFoldable && transfer);
    const displayStandardWavExtraFee =
      wheelchair && standardFoldable && transfer;

    return {
      displayStandard,
      displayWAV,
      displayStandardWavExtraFee,
    };
  }, [params.serviceUserId, serviceData]);

  const handleBack = () => {
    setIsModeSelectionBackBtnClicked(true);
    history.goBack();
  };

  return (
    <div className={styles.selectionContainer}>
      <Row align="middle">
        <Col
          xs={{ offset: 1 }}
          sm={{ offset: 1 }}
          md={{ offset: 1 }}
          lg={{ offset: 4 }}
        >
          <CustomButton
            text="Back"
            handlerFunction={handleBack}
            type="link"
            className="backBtn"
            icon={backArrowIcon}
          />
        </Col>
      </Row>
      <Row justify="center">
        <Col
          xs={{ span: 23, offset: 1 }}
          sm={{ span: 23, offset: 1 }}
          md={{ span: 23, offset: 1 }}
          lg={{ span: 24, offset: 0 }}
          className={`${styles.transportationText} ${styles.centerTextOnLg}`}
        >
          TRANSPORTATION SETUP
        </Col>
      </Row>

      <Row justify="center">
        <Col
          xs={{ span: 23, offset: 1 }}
          sm={{ span: 23, offset: 1 }}
          md={{ span: 23, offset: 1 }}
          lg={{ span: 24, offset: 0 }}
          className={`${styles.selectRideText} ${styles.centerTextOnLg}`}
        >
          Select a ride
        </Col>
      </Row>

      <div className={styles.mediaContainer}>
        {memoizedDisplayOptions.displayStandard && (
          <VehicleCard
            title="Standard"
            description="Sedan-style car"
            isFirstItem={true}
          />
        )}

        {memoizedDisplayOptions.displayWAV && (
          <VehicleCard
            title="WAV"
            description="Wheelchair Accessible Vehicle"
            isFirstItem={true}
          />
        )}

        {memoizedDisplayOptions.displayStandardWavExtraFee && (
          <>
            <VehicleCard
              title="Standard"
              description="Sedan-style car"
              isFirstItem={true}
            />
            <VehicleCard
              title="WAV"
              description="Wheelchair Accessible Vehicle"
              extraFee={wandaTripInfo.wavExtraCost}
              isFirstItem={false}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default React.memo(ModeSelection);
